define('app/shared/filters/calendarFilterDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function calendarFilterDirective($window) {
		return {
			restrict: 'E',
			replace: false,
			scope: {
				data: '=data',
				left: '@left',
				right: '@right'
			},
			templateUrl: 'app/shared/filters/calendarFilter.html',
			link: function(scope, element, attrs) {
				scope.selectMonth = function (month) {
					app.field("month").select([month.qElemNumber], true, false);
				}
				scope.selectYear = function (year) {
					app.field("year").select([year.qElemNumber], true, false);
				}
				scope.$watch('data', function (data) {
					if(data === undefined) {return;}
					scope.months = scope.data.months;
					scope.years = scope.data.years;
				}, true);

				//Show panel stuff
				scope.showPanel = false;
				scope.togglePanel = function () {
					if (!scope.showPanel) scope.openPanel();
					if (scope.showPanel) scope.closePanel();
				}
				scope.openPanel = function () {
					scope.showPanel = true;
					console.log(scope.showPanel);
				}
				scope.closePanel = function () {
					scope.showPanel = false;
				}
				scope.test = function () {
					console.log("outside");
				}
				
			}
		}
	}

	calendarFilterDirective.$inject=['$window'];

  	return calendarFilterDirective;
});
